import React, {useRef } from "react";
function FooterList(props) {
    const id = props.list[0].id;
    let Item = props.list.map ((col, idx) =>
    {    
        return ( 
            <ul key={idx} className="footer__list ">
                <li className="footer__list-item">
                    <a href={col.href}>{col.text}</a>
                </li>
            </ul>
    )});
return (
    <div id={id}>{Item}</div>
)}
export default FooterList;